import { MessageSquareText } from "lucide-react";
import { smsLink } from "@/data/site";
import { useSectionNav } from "@/hooks/useSectionNav";

const MobileActionBar = () => {
  const go = useSectionNav();
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-white/15 bg-obsidian/95 backdrop-blur-md lg:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-action-bar"
    >
      <a
        href={smsLink()}
        className="flex items-center justify-center gap-2 py-4 font-display text-base font-semibold uppercase tracking-wider text-white transition-colors hover:bg-white/5"
        data-testid="mobile-bar-text-us"
      >
        <MessageSquareText size={16} strokeWidth={2.2} />
        Text Us
      </a>
      <button
        onClick={() => go("quote")}
        className="flex items-center justify-center gap-2 bg-steel py-4 font-display text-base font-semibold uppercase tracking-wider text-white transition-colors hover:bg-blue-500"
        data-testid="mobile-bar-quote"
      >
        Get a Quote
      </button>
    </div>
  );
};

export default MobileActionBar;
